import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay } from "swiper";
import { Typography } from "@mui/material";
import Link from "next/link";
import * as constants from "../Components/constants";
import Image from "next/image";
import styles from "../styles/CourseSlider.module.css";
import { style } from "@mui/system";

const BASE_URL = constants.BASE_URL;

const CourseSlider = () => {
  const [allCourses, setAllCourses] = useState([]);

  //getting all courses data
  React.useEffect(() => {
    fetch(`${BASE_URL}/course/all/`)
      .then((res) => res.json())
      .then((data) => {
        if (data.message) {
          alert({ data: data.message });
        } else {
          data.length &&
            data.sort((a, b) => {
              return new Date(b.created_date) - new Date(a.created_date);
            });
          setAllCourses(data);
        }
      });
  }, []);

  if (!allCourses) return <p>No profile data</p>;
  return (
    <>
      {allCourses.length !== 0 && (
        <div className="rounded-3">
          <Swiper
            slidesPerView={1}
            slidesPerGroup={1}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
            pagination={{
              clickable: true,
              dynamicBullets: true,
            }}
            breakpoints={{
              640: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              540: {
                slidesPerView: 2,
                spaceBetween: 40,
              },
              568: {
                slidesPerView: 2,
                spaceBetween: 40,
              },
              712: {
                slidesPerView: 2,
                spaceBetween: 40,
              },
              768: {
                slidesPerView: 1,
                spaceBetween: 40,
              },
              1024: {
                slidesPerView: 1,
                spaceBetween: 40,
              },
              1440: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
            }}
            modules={[Autoplay]}
            className="mySwiper"
          >
            {allCourses.map((course, idx) => (
              <SwiperSlide
                key={idx}
                className="d-flex flex-column"
                style={{ cursor: "pointer" }}
              >
                <Link href={`/course/${course.id}`}>
                  <div className={styles.unset_img}>
                    <Image
                      title={course.name}
                      alt={course.name}
                      src={course.cover_pic}
                      layout="fill"
                      priority
                      className={`${style.custom_img} rounded-2 border`}
                      sizes="(max-width: 768px) 100vw,
                        (max-width: 1200px) 50vw,
                        33vw"
                    />
                  </div>
                </Link>
                <Typography
                  className="text-break p-2 fw-bold"
                  align="center"
                  variant="body2"
                >
                  {course.name}
                </Typography>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}
    </>
  );
};

export default CourseSlider;
